import React from 'react';
import { Box, Flex, Text, VStack } from '@chakra-ui/react';

const GROUPS: { title: string; items: string[] }[] = [
  { title: 'Documents', items: ['DOCX', 'TXT', 'MD', 'HTML', 'RTF'] },
  { title: 'Spreadsheets', items: ['XLSX', 'CSV'] },
  { title: 'Presentations', items: ['PPTX'] },
  { title: 'Images', items: ['PNG', 'JPG', 'WEBP', 'SVG', 'HEIC'] },
  { title: 'Email', items: ['EML', 'MSG'] },
  { title: 'Developer', items: ['JSON', 'XML', 'YAML', 'JS', 'TS', 'PY'] },
];

export const SupportedFormatsSection: React.FC = () => (
  <Box as="footer" py={{ base: 14, md: 20 }} px={{ base: 4, md: 6 }} bg="white" borderTopWidth="1px" borderColor="gray.100">
    <VStack align="stretch" spacing={{ base: 6, md: 8 }} maxW="800px" mx="auto">
      <Text fontSize="xs" fontWeight="600" color="gray.400" letterSpacing="0.06em" textTransform="uppercase">
        Supported formats
      </Text>
      <VStack align="stretch" spacing={{ base: 4, md: 5 }}>
        {GROUPS.map((g) => (
          <Flex
            key={g.title}
            direction={{ base: 'column', sm: 'row' }}
            gap={{ base: 1.5, sm: 6 }}
            align={{ sm: 'baseline' }}
          >
            <Text minW={{ sm: '112px' }} fontSize="sm" fontWeight="600" color="gray.700">
              {g.title}
            </Text>
            <Flex gap={2} flexWrap="wrap" align="center">
              {g.items.map((item) => (
                <Text
                  key={item}
                  as="span"
                  fontSize="xs"
                  fontWeight="500"
                  color="gray.500"
                  px={2.5}
                  py={1}
                  borderRadius="full"
                  bg="gray.50"
                >
                  {item}
                </Text>
              ))}
            </Flex>
          </Flex>
        ))}
      </VStack>
      <Text fontSize="xs" color="gray.400" lineHeight="1.6">
        Legacy binary Word (.doc) and PowerPoint (.ppt) are not supported.
      </Text>
    </VStack>
  </Box>
);
